import { render, staticRenderFns } from "./rowNotes.vue?vue&type=template&id=5fa68d8a&scoped=true"
import script from "./rowNotes.vue?vue&type=script&lang=js"
export * from "./rowNotes.vue?vue&type=script&lang=js"
import style0 from "./rowNotes.vue?vue&type=style&index=0&id=5fa68d8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa68d8a",
  null
  
)

export default component.exports